import Text from '@components/Text';
import colors from '@constants/colors';
import useGoBack from '@hooks/useGoBack';
import ArrowLineLeft from '@icons/arrow/ArrowLineLeft';
import { IconProps } from '@models/icons';
import { JSX, ReactNode } from 'react';

import styles from './styles.module.scss';

interface Props {
    title: string;
    backIcon?: (props: IconProps) => JSX.Element;
    trailing?: ReactNode;
    onBackClick?: () => void;
    noShadow?: boolean;
    noBackIcon?: boolean;
}

function Header(props: Props) {
  const {
    title, backIcon, trailing, onBackClick, noShadow, noBackIcon,
  } = props;
  const goBack = useGoBack();
  const BackIcon = backIcon || ArrowLineLeft;
  return (<header className={`${styles.wrapper} ${noShadow ? styles.noShadow : ''}`} >
      <nav className={styles.container}>
          {noBackIcon ? (
              <span/>
          ) : (<BackIcon size={30}
                         color={colors.gray9}
                         className={styles.back}
                         onClick={onBackClick ?? goBack}/>)}
          <div className={styles.blank}/>
          <Text fontWeight='medium'
                size='lg'
                color={colors.gray9}
                className={styles.smallTitle}>
              {title}
          </Text>
          {trailing}
      </nav>
  </header>);
}

export default Header;
